{
  "Fintraffic-traffic": "Liikennetilanne",
  "Fintraffic-feedback": "Palauteväylä",
  "Fintraffic-train": "Junalähdöt",
  "Fintraffic-digitraffic": "Digitraffic",
  "Fintraffic-digitransit": "Digitransit",
  "Fintraffic-nap": "NAP",
  "Fintraffic-contact": "Yhteystiedot",
  "Fintraffic-contactLink": "yhteystiedot",
  "Fintraffic-privacy": "Tietosuojaseloste",
  "Fintraffic-accessibility": "Saavutettavuus",
  "Fintraffic-about": "Tietoja palvelusta",
  "Fintraffic-instructions": "Ohjeet ja tiedotteet",
  "Fintraffic-terms": "Käyttöehdot",
  "Fintraffic-support": "Tuki",
  "Fintraffic-channels": "Tukikanavat",
  "Fintraffic-fintrafficApp": "Fintraffic Mobiili",
  "Fintraffic-fintrafficAppLink": "digitaalisetpalvelut/mobiili",
  "Entur-cooperation": "Entur yhteistyö",
  "_title": "Pysäkki- ja esteettömyystietokanta"
}
